import request from '@/utils/request'

export function diagnoseAttendanceRedis(onlyAbnormal = true) {
  return request({
    url: '/system/attendanceRedisRepair/diagnose',
    method: 'get',
    params: { onlyAbnormal },
  })
}

export function repairAttendanceRedis(data) {
  return request({
    url: '/system/attendanceRedisRepair/repair',
    method: 'post',
    data,
  })
}

export function repairBatchAttendanceRedis(data) {
  return request({
    url: '/system/attendanceRedisRepair/repairBatch',
    method: 'post',
    data,
  })
}

export function pageAttendanceRedisRepairLog(query) {
  return request({
    url: '/system/attendanceRedisRepair/log/page',
    method: 'get',
    params: query,
  })
}
